import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import NavBar from '../../components/NavBar';
import ProgressiveImageLoader from '../../components/ProgressiveImageLoader';
import Form from './Form';

export default function Home() {

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        )
      );
  
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });
  
  const requestLink = createHttpLink({
    uri:
      process.env.NODE_ENV === "development"
        ? "https://api.pigeonbolt.com/graphql"
        : "https://api.pigeonbolt.com/graphql",
    headers: {
      context: "loyal_customers",
    },
  });
  
  const link = errorLink.concat(requestLink);
  // const link = requestLink;
  
  const client = new ApolloClient({
    link,
    cache: new InMemoryCache(),
  })
  
  return (
    <ApolloProvider client={client}>
      <div className='w-full lg:h-screen lg:flex flex-col'>
          <NavBar />
          <div className='w-full lg:flex lg:flex-1'>
              {/* <img 
                src={'/img/courier-6.png'} 
                alt="" 
                className="hidden lg:block w-5/12 object-cover h-full" 
              /> */}
              <ProgressiveImageLoader
                alt=''
                placeholder='/img/thumbnails/courier-6.jpeg'
                src='/img/courier-6.png'
                className="hidden lg:block w-5/12 object-cover h-full" 
              />
              <div className="w-full lg:w-7/12 lg:h-full lg:flex flex-col">
                  <div className="w-full px-6 lg:px-12">
                      <header className="mt-12">
                          <h4 className="text-2xl font-light">
                          Join our
                          </h4>
                          <h4 className="text-4xl font-bold">
                          Newsletter.
                          </h4>
                      </header>
                      <p className="font-light mt-2">
                          Our vision is to always put our customers at the center of our growth while delivering opportunities without boundaries.
                          <br />
                          <br className='lg:hidden'/>
                          Subscribe to our newsletter to learn more!
                      </p>
                  </div>
                  <Form/>
              </div>
          </div>
      </div>
    </ApolloProvider>
  )
}
